import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router-dom';

// Components
import { PageLayout } from '../PageLayout/PageLayout';

// Styles
import styles from './FallbackError.module.css';

/**
 * Renders a fallback error component.
 *
 * @returns {JSX.Element} The rendered fallback error component.
 */
export function FallbackError() {
  /**
   * @type {object} error
   * @property {string} message
   * */
  const error = useRouteError();
  const { t } = useTranslation();
  return (
    <PageLayout title="" user={{ name: '', photo: '' }} logout={() => { }}>
      <div className={styles.container}>
        <h1 className={styles.title}>{t('common.wrong')}</h1>
        {error?.message ? <h2 className={styles.msg}>{error.message}</h2> : null}
      </div>
    </PageLayout>
  );
}

export default FallbackError;
